import PropTypes from "prop-types"
import React from "react"
import { AiOutlineMinus as Minus, AiOutlinePlus as Plus } from "react-icons/ai"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function _QuantitySelector(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, value, onChange, label } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleNaN(num) {
        return isNaN(num) ? 1 : num
    }

    const increment = () => onChange(handleNaN(value + 1))

    const decrement = () => value > 0 && onChange(handleNaN(value - 1))

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <div className={`${className}`}>
            <div className="label">{label}</div>
            <div className="selector">
                <button className="button plus" onClick={decrement}>
                    <Minus />
                </button>
                <div className="space" />
                <div className="value">{value ? value : 0}</div>
                <div className="space" />
                <button className="button minus" onClick={increment}>
                    <Plus />
                </button>
            </div>
        </div>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_QuantitySelector.propTypes = {
    className: PropTypes.string.isRequired,
    value: PropTypes.number,
    onChange: PropTypes.func,
    label: PropTypes.string,
}

_QuantitySelector.defaultProps = {}

// ----------------------------------------------------------------------------

const QuantitySelector = styled(_QuantitySelector)`
    & {
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 300px;
        .label {
            display: block;
            font-weight: 400;
            font-size: 16px;
            margin-bottom: 10px;
            color: ${({ theme }) => theme?.colors?.dark};
        }
        .selector {
            display: flex;
            align-items: center;
            justify-content: center;
            .space {
                width: 15px;
            }

            .button {
                display: block;
                width: 34px;
                height: 34px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: white;
                border: 1px solid ${({ theme }) => theme.colors.dark250};
                border-radius: 50%;
                cursor: pointer;

                svg {
                    width: 20px;
                    height: 20px;
                    fill: ${({ theme }) => theme.colors.dark400};
                }
            }

            .value {
                font-size: 16px;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default QuantitySelector
